import React, { Component } from 'react'
import { Button, Icon } from 'antd'
import ModalVideo from 'react-modal-video'

const styles = {
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 80
  },
  button: {
    width: 259,
    height: 50,
    borderRadius: 30,
    backgroundColor: '#f67118',
    fontSize: 18,
    fontWeight: 500,
    color: '#ffffff',
    border: 'none'
  }
}

class WatchToLearnMore extends Component {
  state = {
    isOpen: false
  }

  showModal = () => {
    this.setState({
      isOpen: true
    })
  }

  hideModal = () => {
    this.setState({
      isOpen: false
    })
  }

  render() {
    return (
      <div>
        <div style={styles.container}>
          <Button style={styles.button} onClick={this.showModal}>
            <Icon type="play-circle-o" /> Watch to learn more!
          </Button>
        </div>
        <ModalVideo
          channel="youtube"
          isOpen={this.state.isOpen}
          videoId="Mmf_lR2Zlbg"
          onClose={this.hideModel}
        />
      </div>
    )
  }
}

export default WatchToLearnMore



// WEBPACK FOOTER //
// ./src/components/home/WatchToLearnMore.js